import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

const InfoCard = ({ label, value, icon, children }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 1.5,
      borderRadius: 1.5,
      borderColor: 'divider',
      height: '100%',
      bgcolor: '#ffffff'
    }}
  >
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: 1.5,
          bgcolor: '#F8FAFC',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, width: '100%' }}>
        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>
          {label}
        </Typography>
        {children || (
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              color: '#0f172a',
              overflowWrap: 'anywhere',
              lineHeight: 1.3
            }}
          >
            {value}
          </Typography>
        )}
      </Box>
    </Stack>
  </Paper>
);

export default InfoCard;
